import { EditCalendar, PersonOutlineOutlined } from '@mui/icons-material'
import { FC, ReactNode } from 'react'

import { MUITooltip } from 'components/common/MUITooltip'
import { Stack } from '@mui/material'
import classnames from 'classnames'
import i18n from 'translations/i18n'
import moment from 'moment'
import styles from './OrderCreator.module.sass'
import { useGalleryDeal } from '../../../contexts'
import { useTranslation } from 'react-i18next'

/**
 * @interface Props
 */
interface Props {
  // Align the content vertically for smaller width boxes purposes
  verticalAlignment: boolean
  // Optional slot rendered after owner + date in the info row
  children?: ReactNode
}

export const OrderCreator: FC<Props> = ({ verticalAlignment = false, children }) => {
  const { t } = useTranslation(['gallery'])

  const { dealData } = useGalleryDeal()

  if (!dealData) return <></>

  return (
    <Stack flexDirection={verticalAlignment ? 'column' : 'row'} alignItems={verticalAlignment ? 'left' : 'flex-start'} gap="2.4rem" flexWrap="wrap">

      <Stack direction="row" alignItems="center">
        <PersonOutlineOutlined className={classnames(styles.icon, styles.person)} />
        <span className={styles.owner}>{dealData.customer.name}</span>
      </Stack>

      <MUITooltip
        content={t('placed_on', { date: moment(dealData.createdAt).locale(i18n.language).format('MMMM Do YYYY, h:mm A') })}
        type="secondary"
        placement="bottom"
      >
        <Stack direction="row" alignItems="center">
          <EditCalendar className={classnames(styles.icon, styles.date)} />
          <span className={styles.owner}>{moment(dealData.createdAt).locale(i18n.language).format('MMMM Do YYYY, h:mm A')}</span>
        </Stack>
      </MUITooltip>

      {children}

    </Stack>
  )
}
